const getValuesFromLocalStorage = (store) => {
    const config = [
        {
            key: 'query',
            mutation: 'setSearchQuery',
        },
        {
            key: 'filters',
            mutation: 'setFilters',
        }
    ];

    config.forEach(({key, mutation}) => {
        if (localStorage.getItem(key)) {
            try {
                let value = JSON.parse(localStorage.getItem(key));
                store.commit(mutation, value);
            } catch (e) {
                console.log(e);
                localStorage.removeItem(key);
            }
        }
    });
};

const setUpcomingEvents = (store) => {
    // Upcoming events are injected into the blade view as a variable bound to the window
    store.commit('setUpcomingEvents', window.upcomingEvents);
};

const verifySelectedEvents = (store) => {
    // Make sure we haven't got any events selected that are no longer upcoming
    let selected_events = store.state.filters.selected_events.filter(selectedEventId => {
        let matches = store.state.upcomingEvents.filter(upcomingEvent => {
            return upcomingEvent.id === selectedEventId;
        });

        return matches.length > 0;
    });

    store.commit('setFilters', {
        ...store.state.filters,
        selected_events
    });
};


const initialiseStore = (store) => {
    setUpcomingEvents(store);
    getValuesFromLocalStorage(store);
    verifySelectedEvents(store);
};

export default initialiseStore
